import android from '@/assets/images/car-details/android-auto-icon.png';
import apple from '@/assets/images/car-details/apple-carplay-logo.png';
import bluetooth from '@/assets/images/car-details/bluetooth-logo-png-transparent.png';
import satnav from '@/assets/images/car-details/satnav-logo.png';
import Image from 'next/image';
import { VEHICLE_BY_SLUG_QUERYResult } from 'sanity.types';

type VehicleFeatures = NonNullable<VEHICLE_BY_SLUG_QUERYResult>['features'];

const VehicleSideFeatures = ({ features }: { features: VehicleFeatures }) => {
    return (
        <div className="pl-4 pr-4 grow flex flex-row sm:flex-col items-center justify-around sm:justify-center border-t mr-4 sm:mr-0 sm:border-l sm:border-t-0 border-gray-300">
            {features?.includes('Android Auto') && (
                <div className="flex flex-wrap justify-center my-4">
                    <Image
                        unoptimized={true}
                        src={android}
                        alt="Android Auto"
                        width={34}
                        height={34}
                        className="mb-2"
                    />
                    <div className="w-full text-center text-xs whitespace-nowrap">
                        Android Auto
                    </div>
                </div>
            )}
            {features?.includes('Apple CarPlay') && (
                <div className="flex flex-wrap justify-center my-4">
                    <Image
                        unoptimized={true}
                        src={apple}
                        alt="Apple Carplay"
                        width={34}
                        height={34}
                        className="mb-2"
                    />
                    <div className="w-full text-center text-xs whitespace-nowrap">
                        Apple CarPlay
                    </div>
                </div>
            )}
            {features?.includes('Bluetooth') && (
                <div className="flex flex-wrap justify-center my-4">
                    <Image
                        unoptimized={true}
                        src={bluetooth}
                        alt="Bluetooth"
                        width={100}
                        height={34}
                    />
                </div>
            )}
            {features?.includes('Satnav') && (
                <div className="flex flex-wrap justify-center my-4">
                    <Image
                        unoptimized={true}
                        src={satnav}
                        alt="Sat Nav"
                        width={80}
                        height={34}
                    />
                </div>
            )}
        </div>
    );
};

export default VehicleSideFeatures;
